import { AppRoute } from '@agentselly/immodossier-shared';
import { SignUp } from '@clerk/clerk-react';
import { useLinkProps } from '@tanstack/react-router';
import { useTheme } from '~/context/ThemeContext';
import { dark } from '@clerk/themes';

export function ClerkRegisterWidget() {
  const { resolvedTheme } = useTheme();
  const { href: signInUrl } = useLinkProps({
    to: AppRoute.$LANG_$COMPANYID_INDEX as any,
  });
  const { href: waitlistUrl } = useLinkProps({
    to: AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_WAITLIST as any,
  });

  return (
    <div className="h-full bg-white dark:bg-gray-800 drop-shadow-md rounded-xl block overflow-x-hidden">
      <SignUp
        signInUrl={signInUrl}
        waitlistUrl={waitlistUrl}
        appearance={{
          baseTheme: resolvedTheme === 'dark' ? dark : undefined,
          elements: {
            rootBox: 'w-full h-full',
            cardBox: 'rounded-none shadow-none w-full h-full',
          },
        }}
      />
    </div>
  );
}
